import { DecimalPipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiModulesService } from 'src/app/api-modules.service';
import { NgbdSortableHeader, SortEvent } from 'src/app/shared/directives/NgbdSortableHeader';
import { TableService } from 'src/app/shared/service/table.service';
import { LISTPAGEDB, ListPagesDB } from 'src/app/shared/tables/list-pages';

@Component({
  selector: 'app-viewpages',
  templateUrl: './viewpages.component.html',
  styleUrls: ['./viewpages.component.scss'],
  providers:[TableService,DecimalPipe]
})

export class ViewpagesComponent implements OnInit {
 
  
  name:any;

  public selected = [];
  public tableItem$: Observable<ListPagesDB[]>;
  public searchText;
  
  public editID:any;
   visible:any=true;
  total$: Observable<number>;
  public viewpages:ListPagesDB[] = [];

  viewchannelrequest:FormGroup;
  @Input()id=[];
  @Output() visibleParentPage:EventEmitter<any>=new EventEmitter<any>();
  formBuilder: any;
  viewmessage: any;

  page: number;
  pageSize: number; 
 
  constructor(private apiModulesService: ApiModulesService,public service: TableService,public formbuilder:FormBuilder,private route: ActivatedRoute) {
    this.tableItem$ = service.tableItem$;
    this.total$ = service.total$;
    this.service.setUserData(LISTPAGEDB);
  }
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

 
  onSort({ column, direction }: SortEvent) 
  {
    console.log(this);
    this.headers.forEach((header) => 
    {
      if (header.sortable !== column) 
      {
        header.direction = '';
      }
    });

    this.service.sortColumn = column;
    this.service.sortDirection = direction;

  }

  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }
 
  ngOnInit(): void {
    this.getChannels();
  }

//  public Viewchannelrequest(){
//   this.apiModulesService.get("telegram/channel/view_channel_request").subscribe((data)=>{
//     console.log(data);
//   this.selected = data;

//   });

//  }

 viewChannelRequest() {
  this.apiModulesService.get("telegram/channel/view_channel_request").subscribe((data) => {
      console.log(data);
      // Optionally, you can assign the response to this.selected if needed
      // this.selected = data;
    });
}
public moveToMainPage(){
  this.visibleParentPage.emit(true);

}
public getChannels(){
  const params:any={};
  params.id=this.id;
  this.apiModulesService.add(params,"telegram/channel/view_message_request").subscribe((data)=>{
    let channels=data;
    this.viewpages=data;
    console.log(this.viewpages);
  });
 
}
}
  
